<template>
  <div class="self_main">
    <SettingSlider pageName="selfInfo" />
    <div class="rightArea">
      <div class="contentArea">
        <div class="item">责任单位：{{ userInfo.account }}</div>
        <div class="item">责任人： {{ userInfo.userName }}</div>
        <div class="item">联系电话：{{ userInfo.mobile }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import SettingSlider from "../../components/SettingSlider.vue";
import storeUtil from "../../utils/storeUtil.js";

export default {
  name: "userManager",
  components: {
    SettingSlider: SettingSlider,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  mounted() {
    this.userInfo = storeUtil.getUserInfo();
  },
  methods: {},
};
</script>
<style scoped lang="less">
.self_main {
  display: flex;
  height: 984px;
}
.rightArea {
  flex: 1;
  background-color: #f6f9fc;
  border-top: 1px #f6f9fc solid;

  .contentArea {
    height: 900px;
    background-color: white;
    margin-left: 25px;
    margin-right: 58px;
    margin-top: 48px;
    padding: 48px 0px;

    .item {
      margin-top: 38px;
      margin-left: 58px;
    }
  }
}
</style>
